import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/followedCards/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const REMOVE_ARRAY = NAMESPACE + 'REMOVE_ARRAY'
export const REMOVE_ALL = NAMESPACE + 'REMOVE_ALL'

const initialState = {
  followedCardIds: [],
  followedCardsById: {},
  isLoading: false,
  isLoaded: false
}

const followedCardDefaults = {
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD:
      return {
        ...state,
        followedCardIds: addUniqueValueToArray({
          array: state.followedCardIds,
          value: action.payload.id,
          index: action.payload.index
        }),
        followedCardsById: {
          ...state.followedCardsById,
          [action.payload.id]: {
            ...followedCardDefaults,
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        followedCardIds: [ ...state.followedCardIds ],
        followedCardsById: { ...state.followedCardsById }
      }
      action.payload.forEach(item => {
        newState.followedCardIds = addUniqueValueToArray({
          array: newState.followedCardIds,
          value: item.id,
          index: item.index
        })
        newState.followedCardsById[item.id] = {
          ...followedCardDefaults,
          ...item
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        followedCardIds: [ ...state.followedCardIds.filter(id => id !== action.payload.id) ],
        followedCardsById: { ...state.followedCardsById }
      }
      delete newState.followedCardsById[action.payload.id]
      return newState
    }
    case REMOVE_ARRAY: {
      const idsToDelete = []

      const newState = {
        ...state,
        followedCardIds: [
          ...state.followedCardIds.filter(id => {
            if (action.payload.indexOf(id) !== -1) {
              idsToDelete.push(id)

              return false
            }

            return true
          })
        ],
        followedCardsById: { ...state.followedCardsById }
      }

      idsToDelete.forEach(id => {
        delete newState.followedCardsById[id]
      })

      return newState
    }
    case REMOVE_ALL:
      return {
        ...state,
        followedCardIds: [],
        followedCardsById: {}
      }
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function removeArray (ids) {
  return {
    type: REMOVE_ARRAY,
    payload: ids
  }
}

export function removeAll () {
  return {
    type: REMOVE_ALL
  }
}
